import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { collection, onSnapshot, query, where, getDocs } from "firebase/firestore";

export function useItems(env, client) {
  const [loadedItems, setLoadedItems] = useState(false);
  const [items, setItems] = useState(null);

  useEffect(() => {
    setLoadedItems(false);
    if (!client) {
      setLoadedItems(true);
      return () => [];
    }
    const ref = collection(db, "kiosk", env, "client", client, "items");

    // onSnapshot = reactivo + offline + cache
    const unsub = onSnapshot(ref, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setItems(data);
      setLoadedItems(true);
    });

    return () => unsub();
  }, [env, client]);

  return {loadedItems, items};
}

export async function fetchItemsByEan(env, client, ean) {
  if (!client) return [];
  const ref = collection(db, "kiosk", env, "client", client, "items");
  const q = query(ref, where("ean", "==", ean));

  const snapshot = await getDocs(q);
  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
}

export function getMaxPerItem(product, storeId, filteredStoreIds) {
  const storesWithStock = [storeId];
    filteredStoreIds.forEach(backupStore => {
      if (!storesWithStock.includes(backupStore)) storesWithStock.push(backupStore);
    });
    let maxPerItem;
    for (let i = 0; i < storesWithStock.length; i++) {
      const storeWithStock = storesWithStock[i];
      maxPerItem = product.info_stores?.[storeWithStock]?.max_per_item;
      if (maxPerItem) break;
    }
    if (!maxPerItem) maxPerItem = 1;
    return maxPerItem;
}